import * as React from "react";
const SvgTime = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.168 12c0 5.43 4.403 9.833 9.833 9.833 5.432 0 9.834-4.403 9.834-9.834 0-5.43-4.402-9.833-9.833-9.833s-9.834 4.402-9.834 9.833M12.001.665C5.743.666.668 5.74.668 11.999s5.074 11.334 11.334 11.334 11.333-5.074 11.333-11.334S18.261.666 12.002.666",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.967 6.966a.748.748 0 1 1 1.496 0v6.018a.748.748 0 0 1-1.496 0z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.2 12.416a.748.748 0 1 0 0 1.497h4.515a.748.748 0 1 0 0-1.497z"
  }
));
export default SvgTime;
